export default [
    {
        path: "/user",
        component: "../layouts/UserLayout",
        cannotRedirectTo: true,
        routes: [
            {
                name: "login",
                path: "/user/login",
                component: "./user/login",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "twoFactor",
                path: "/user/two-factor",
                component: "./user/two-factor",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "phoneVerification",
                path: "/user/phone-verification",
                component: "./user/phone-verification",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "register",
                path: "/user/register",
                component: "./user/register",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "confirmEmail",
                path: "/user/confirm-email",
                component: "./user/confirmEmail",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "dealer",
                path: "/user/register/dealer",
                component: "./user/register/dealer",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "forgotPassword",
                path: "/user/forgotPassword",
                component: "./user/forgotPassword/",
                cannotRedirectTo: true,
                public: true,
            },
            {
                name: "restPassword",
                path: "/user/reset-password",
                component: "./user/resetPassword/",
                cannotRedirectTo: true,
                public: true,
            },
        ],
    },
    {
        path: "/invite",
        component: "./InviteUser",
        cannotRedirectTo: true,
        public: true,
    },
    {
        path: "/redirect/secure-pass",
        component: "./SecurePass/SecurePassLogger/SecurePassLogger",
        hideInMenu: true,
        public: true,
    },
    {
        path: "/secure-pass",
        component: "./SecurePass/SecurePass",
        hideInMenu: true,
        public: true,
    },
    {
        path: "/",
        component: "../layouts/MaintenanceModeLayout",
        cannotRedirectTo: true,
        routes: [
            {
                path: "/redirect/quick-quote",
                component: "./QuickQuoteRedirect",
                hideInMenu: true,
            },
            {
                path: "/redirect/create-shipment",
                component: "./CreateShipmentRedirect",
                hideInMenu: true,
            },
            {
                path: "/invite-existing",
                component: "./InviteUser",
                cannotRedirectTo: true,
            },
            {
                path: "/change-temp-password",
                component: "./ChangeTempPassword",
                cannotRedirectTo: true,
            },
            {
                path: "/",
                component: "../layouts/BasicLayout",
                authority: true,
                routes: [
                    {
                        path: "/",
                        component: "../layouts/RedirectLayout",
                        authority: true,
                        cannotRedirectTo: true,
                    },
                    {
                        name: "Dashboard",
                        icon: "dashboard",
                        path: "/dashboard",
                        component: "./Dashboard",
                        authority: ["CoreService.Dashboards.Dealer", "CoreService.Dashboards.Transporter"],
                    },
                    {
                        name: "Dashboard",
                        path: "/admin/dashboard",
                        component: "./AdminDashboard",
                        icon: "dashboard",
                        authority: ["CoreService.Dashboards.Admin"],
                    },
                    {
                        name: "BDM Dashboard",
                        path: "/bdm/dashboard",
                        component: "./BDMDashboard",
                        icon: "dashboard",
                        authority: ["CoreService.Dashboards.BDM"],
                    },
                    {
                        name: "Quick Quote",
                        icon: "Thunder",
                        path: "/quick-quotes",
                        component: "./QuickQuotes",
                        authority: ["PricingService.QuickQuotes.Create"],
                    },
                    {
                        name: "Quick Quotes",
                        icon: "AdminQuickQuotes",
                        path: "/admin/quick-quotes",
                        component: "./AdminQuickQuotes",
                        qs: "source=menu",
                        authority: ["PricingService.QuickQuotesAdmin"],
                    },
                    {
                        name: "Shipments",
                        icon: "carry-out",
                        path: "/admin/shipments",
                        component: "./AdminShipments",
                        authority: ["CoreService.AdminShipments"],
                    },
                    {
                        name: "Shipment View",
                        path: "/admin/shipments/view",
                        component: "./AdminShipments/AdminShipmentView",
                        authority: ["CoreService.AdminShipments"],
                        hideInMenu: true,
                    },
                    {
                        name: "Messages",
                        path: "/admin/shipments/view/messages",
                        component: "./PricingEngineMessages",
                        authority: ["PricingService.QuoteRuleResults"],
                        hideInMenu: true,
                    },
                    {
                        name: "Create Shipment",
                        path: "/admin/shipments/create",
                        component: "./CreateShipment",
                        authority: ["CoreService.AdminShipments"],
                        hideInMenu: true,
                        cannotRedirectTo: true,
                    },
                    {
                        name: "Edit Shipment",
                        path: "/admin/shipments/edit",
                        component: "./ShipmentList/EditShipment",
                        authority: ["CoreService.AdminShipments"],
                        hideInMenu: true,
                    },
                    {
                        name: "Create Shipment",
                        icon: "plus",
                        path: "/create",
                        component: "./CreateShipment",
                        authority: ["CoreService.Shipments.Create"],
                        cannotRedirectTo: true,
                    },
                    // Disclaimer: We NEED to create this top level entry to avoid breaking all the routes bellow /quotes menu (even for non-dealers users)
                    // this entry is the real entry for my-quick-quotes page, while the other my-quick-quotes entry is just the link to this one
                    {
                        name: "Quick Quotes",
                        path: "/my-quick-quotes",
                        component: "./DealerQuickQuotes",
                        hideInMenu: true,
                        authority: ["PricingService.QuickQuotes"],
                    },
                    {
                        name: "Quotes",
                        icon: "file-search",
                        path: "/quotes",
                        authority: ["CoreService.Quotes"],
                        routes: [
                            {
                                name: "Single Quote View",
                                path: "/quotes/single/view",
                                component: "./Quotes/SingleQuote",
                                hideInMenu: true,
                            },
                            {
                                name: "Draft",
                                path: "/quotes/draft",
                                component: "./Quotes",
                                qs: "page=1&pageSize=10&sorting=creationTime:desc",
                            },
                            {
                                name: "Pending Quotes",
                                path: "/quotes/pending",
                                component: "./Quotes",
                                qs: "page=1&pageSize=10&sorting=creationTime:desc",
                                authority: ["CoreService.Quotes"],
                            },
                            {
                                name: "My Quick Quotes",
                                icon: "Thunder",
                                path: "/my-quick-quotes",
                                component: "./DealerQuickQuotes",
                                authority: ["PricingService.QuickQuotes"],
                            },
                            {
                                name: "Completed",
                                path: "/quotes/completed",
                                component: "./Quotes",
                                qs: "page=1&pageSize=10&sorting=creationTime:desc",
                            },
                            {
                                name: "Expired",
                                path: "/quotes/expired",
                                component: "./Quotes",
                                qs: "page=1&pageSize=10&sorting=creationTime:desc",
                            },
                            {
                                name: "Completed",
                                path: "/quotes/completed/view",
                                component: "./ShipmentList/ShipmentDetails",
                                hideInMenu: true,
                                authority: ["CoreService.Shipments"],
                            },
                            {
                                name: "Completed",
                                path: "/quotes/admin/completed/view",
                                component: "./AdminShipments/AdminShipmentView",
                                hideInMenu: true,
                                authority: ["CoreService.AdminShipments"],
                            },
                            {
                                name: "Shipment Details",
                                path: "/quotes/pending/view",
                                component: "./ShipmentList/ShipmentDetails",
                                hideInMenu: true,
                            },
                            {
                                name: "Shipment Details",
                                path: "/quotes/admin/pending/view",
                                component: "./ShipmentList/ShipmentDetails",
                                hideInMenu: true,
                            },
                            {
                                name: "Quotes View",
                                path: "/quotes/:path/view",
                                component: "./ShipmentList/ShipmentDetails",
                                hideInMenu: true,
                            },
                        ],
                    },
                    {
                        name: "Transporter Details",
                        path: "/dealer/transporter/view",
                        authority: ["CoreService.Transporters"],
                        component: "./ShipmentList/TransporterDetails",
                        hideInMenu: true,
                    },
                    {
                        name: "Dealer Shipments",
                        icon: "carry-out",
                        path: "/shipments",
                        authority: ["CoreService.Shipments"],
                        routes: [
                            {
                                path: "/shipments",
                                redirect: "/shipments/dealer/all",
                            },
                            {
                                name: "All Shipments",
                                path: "/shipments/dealer/all",
                                component: "./ShipmentList",
                            },
                            {
                                name: "Posted",
                                path: "/shipments/dealer/posted",
                                component: "./ShipmentList",
                            },
                            {
                                name: "Assigned",
                                path: "/shipments/dealer/assigned",
                                component: "./ShipmentList",
                            },
                            {
                                name: "Delivered",
                                path: "/shipments/dealer/delivered",
                                component: "./ShipmentList",
                            },
                            {
                                name: "Shipment Details",
                                path: "/shipments/dealer/:path/view",
                                component: "./ShipmentList/ShipmentDetails",
                                hideInMenu: true,
                            },
                            {
                                name: "Edit Shipment",
                                path: "/shipments/dealer/edit",
                                component: "./ShipmentList/EditShipment",
                                hideInMenu: true,
                            },
                        ],
                    },
                    {
                        name: "Transporter Loads",
                        icon: "reconciliation",
                        path: "/loads",
                        authority: ["CoreService.AvailableLoads", "CoreService.AssignedLoads"],
                        routes: [
                            {
                                path: "/loads",
                                redirect: "/loads/all",
                            },
                            {
                                name: "Available Shipments",
                                subname: "Loads",
                                path: "/loads/shipments",
                                component: "./AvailableShipments",
                                authority: ["CoreService.AvailableLoads"],
                            },
                            {
                                name: "Shipment Details",
                                path: "/loads/shipments/view",
                                component: "./ShipmentList/TransporterShipmentView",
                                hideInMenu: true,
                                authority: ["CoreService.AvailableLoads"],
                            },
                            {
                                name: "All Loads",
                                subname: "Loads",
                                path: "/loads/all",
                                component: "./TransporterLoads",
                                authority: ["CoreService.AssignedLoads"],
                            },
                            {
                                name: "In Progress",
                                subname: "Loads",
                                path: "/loads/progress",
                                component: "./TransporterLoads",
                                authority: ["CoreService.AssignedLoads"],
                            },
                            {
                                name: "Delivered",
                                subname: "Loads",
                                path: "/loads/delivered",
                                component: "./TransporterLoads",
                                authority: ["CoreService.AssignedLoads"],
                            },
                            {
                                name: "Completed",
                                subname: "Loads",
                                path: "/loads/completed",
                                component: "./TransporterLoads",
                                authority: ["CoreService.AssignedLoads"],
                            },
                            {
                                name: "Transporter Loads Details",
                                path: "/loads/:path/view",
                                component: "./TransporterLoads/LoadsView",
                                hideInMenu: true,
                                authority: ["CoreService.AssignedLoads"],
                            },
                        ],
                    },
                    {
                        name: "Vehicle Details",
                        path: "/vehicles/view",
                        component: "./Vehicles/VehicleView",
                        hideInMenu: true,
                        authority: [
                            "CoreService.AdminShipments.Vehicles",
                            "CoreService.Shipments.Vehicles",
                            "CoreService.AvailableLoads",
                            "CoreService.AssignedLoads",
                        ],
                    },
                    {
                        name: "Edit Vehicle",
                        path: "/vehicles/edit",
                        component: "./Vehicles/EditVehicle",
                        authority: ["CoreService.Shipments.Vehicles.Edit", "CoreService.AdminShipments.Vehicles.Edit"],
                        hideInMenu: true,
                    },
                    {
                        name: "Dealer Reports",
                        icon: "AreaChartOutlined",
                        path: "/dealer/reports",
                        component: "./Reports",
                        authority: ["CoreService.Reports.Dealer"],
                    },
                    {
                        name: "Transporter Reports",
                        icon: "BarChartOutlined",
                        path: "/transporter/reports",
                        component: "./Reports",
                        authority: ["CoreService.Reports.Transporter"],
                    },
                    {
                        name: "Shipper Intelligence",
                        icon: "project",
                        path: "/dealer/shipperintelligence",
                        component: "./GroupReports",
                        authority: ["CoreService.Reports.ShipperIntelligence"],
                    },
                    {
                        name: "Settings",
                        icon: "setting",
                        path: "/settings",
                        component: "./Settings",
                        hideInMenu: true,
                        authority: ["IdentityService.Profiles", "CoreService.Companies"],
                    },
                    {
                        name: "Notifications",
                        path: "/notifications",
                        component: "./Notifications",
                        hideInMenu: true,
                        authority: ["NotificationService.UserNotificationSettings"],
                    },
                    {
                        name: "Dealer View",
                        path: "/settings/dealer",
                        component: "./Settings/components/SingleDealerView",
                        hideInMenu: true,
                        authority: ["CoreService.Companies"],
                    },
                    {
                        name: "Transporter View",
                        path: "/settings/transporter",
                        component: "./Settings/components/SingleTransporterView",
                        hideInMenu: true,
                        authority: ["CoreService.Companies"],
                    },
                    {
                        name: "Pricing History",
                        icon: "dollar",
                        path: "/admin/pricinghistory",
                        component: "./AdminPricingHistory",
                        authority: ["CoreService.PricingHistories"],
                    },
                    {
                        name: "Dealer Entities",
                        icon: "contacts",
                        path: "/admin/dealers",
                        component: "./Dealers",
                        qs: "page=1&pageSize=10&filters=flagStatus:1_",
                        authority: ["CoreService.Dealers"],
                    },
                    {
                        name: "Add Dealer",
                        icon: "contacts",
                        path: "/admin/dealers/add",
                        component: "./Dealers/AddDealer",
                        hideInMenu: true,
                        authority: ["CoreService.Dealers.Create"],
                    },
                    {
                        name: "Dealer View",
                        path: "/admin/dealers/view",
                        component: "./Dealers/SingleDealer",
                        authority: ["CoreService.Dealers"],
                        hideInMenu: true,
                    },
                    {
                        name: "Pricing Strategies",
                        path: "/admin/dealers/strategies",
                        component: "./Dealers/SingleDealer/Strategies",
                        authority: ["PricingService.PricingSettings"],
                        hideInMenu: true,
                    },
                    {
                        name: "Transporter Entities",
                        icon: "contacts",
                        path: "/admin/transporters",
                        component: "./Transporters",
                        authority: ["CoreService.Transporters"],
                    },
                    {
                        name: "Transporter View",
                        path: "/admin/transporters/view",
                        component: "./Transporters/SingleTransporter",
                        authority: ["CoreService.Transporters"],
                        hideInMenu: true,
                    },
                    {
                        name: "Add Transporter",
                        icon: "contacts",
                        path: "/admin/transporters/add",
                        component: "./Transporters/AddTransporter",
                        hideInMenu: true,
                        authority: ["CoreService.Transporters.Create"],
                    },
                    {
                        name: "Users",
                        icon: "user",
                        path: "/admin/users",
                        component: "./Users",
                        qs: "page=1&pageSize=10&filters=isActive:true_",
                        authority: ["IdentityService.User"],
                    },
                    {
                        name: "Users View",
                        path: "/admin/users/view",
                        component: "./Users/SingleUser",
                        authority: ["IdentityService.User"],
                        hideInMenu: true,
                    },
                    {
                        name: "Add User",
                        path: "/admin/users/add",
                        component: "./Users/AddUser",
                        authority: ["IdentityService.User"],
                        hideInMenu: true,
                    },
                    {
                        name: "Admin Users",
                        icon: "user",
                        path: "/admin/adminusers",
                        component: "./AdminUsers",
                        qs: "page=1&pageSize=10&filters=isActive:true_",
                        authority: ["IdentityService.AdminUser"],
                    },
                    {
                        name: "Admin Users View",
                        icon: "user",
                        path: "/admin/adminusers/view",
                        component: "./AdminUsers/SingleUser",
                        authority: ["IdentityService.AdminUser"],
                        hideInMenu: true,
                    },
                    {
                        name: "Add Admin User",
                        path: "/admin/adminusers/add-admin",
                        component: "./Users/AddUser",
                        authority: ["IdentityService.AdminUser"],
                        hideInMenu: true,
                    },
                    {
                        name: "SecurePass™ Logs",
                        icon: "safety",
                        path: "/admin/secure-pass-logs",
                        component: "./AdminSecurePassLogs",
                        authority: ["MediaService.SecurePassLogs"],
                    },
                    {
                        name: "Address Book",
                        icon: "book",
                        path: "/addresses",
                        component: "./AddressBook",
                        authority: ["CoreService.Addresses"],
                    },
                    {
                        name: "Address Book View",
                        path: "/addresses/view",
                        component: "./AddressBook/AddressView",
                        authority: ["CoreService.Addresses"],
                        hideInMenu: true,
                    },
                    {
                        name: "Add User",
                        icon: "user-add",
                        path: "/add-user",
                        component: "./Settings/components/AddUser",
                        authority: ["CoreService.Companies.Users.Create"],
                    },
                    {
                        name: "Entity Groups",
                        icon: "team",
                        path: "/admin/entitygroups",
                        component: "./AdminEntityGroups",
                        authority: ["CoreService.CompanyGroups"],
                    },
                    {
                        name: "Entity Groups View",
                        path: "/admin/entitygroups/view",
                        component: "./AdminEntityGroups/AdminEntityGroupView",
                        authority: ["CoreService.CompanyGroups"],
                        hideInMenu: true,
                    },
                    {
                        name: "Entity Groups Pricing Strategies",
                        path: "/admin/entitygroups/strategies",
                        component: "./AdminEntityGroups/AdminEntityGroupView/Strategies",
                        authority: ["CoreService.CompanyGroups"],
                        hideInMenu: true,
                    },
                    {
                        name: "Payments",
                        path: "/admin/payments",
                        component: "./AdminPricing",
                        authority: ["CoreService.Payments"],
                        icon: "dollar",
                    },
                    {
                        name: "Payments View",
                        path: "/admin/payments/view",
                        component: "./AdminPricing/AdminPricingView",
                        authority: ["CoreService.Payments"],
                        hideInMenu: true,
                    },
                    {
                        name: "WWL/Nissan",
                        path: "/admin/wwl-nissan",
                        icon: "deployment-unit",
                        authority: [
                            "NissanService.Dealers",
                            "NissanService.Colors",
                            "NissanService.Dealers",
                            "NissanService.Models",
                            "NissanService.Vehicles",
                            "NissanService.VPCLocations",
                        ],
                        routes: [
                            {
                                name: "Tender File Input",
                                path: "/admin/wwl-nissan/tender-file-input",
                                component: "./WWLNissan/TenderFileInput",
                                authority: ["NissanService.Vehicles"],
                                icon: "profile",
                                qs: "page=1&pageSize=10&filters=nissanVehicleStatus:1_",
                            },
                            {
                                name: "Nissan Dealers",
                                icon: "carry-out",
                                path: "/admin/wwl-nissan/nissan-dealers",
                                authority: ["NissanService.Dealers"],
                                routes: [
                                    {
                                        path: "/admin/wwl-nissan/nissan-dealers",
                                        component: "./WWLNissan/NissanDealers",
                                    },
                                ],
                            },
                            {
                                name: "Nissan Colors",
                                icon: "carry-out",
                                path: "/admin/wwl-nissan/nissan-colors",
                                authority: ["NissanService.Colors"],
                                routes: [
                                    {
                                        path: "/admin/wwl-nissan/nissan-colors",
                                        component: "./WWLNissan/NissanColors",
                                    },
                                ],
                            },
                            {
                                name: "Tender Models",
                                icon: "carry-out",
                                path: "/admin/wwl-nissan/nissan-models",
                                authority: ["NissanService.Models"],
                                routes: [
                                    {
                                        path: "/admin/wwl-nissan/nissan-models",
                                        component: "./WWLNissan/NissanModels",
                                    },
                                ],
                            },
                            {
                                name: "Nissan Pricing",
                                icon: "carry-out",
                                path: "/admin/wwl-nissan/nissan-pricing",
                                authority: ["NissanService.Prices"],
                                routes: [
                                    {
                                        path: "/admin/wwl-nissan/nissan-pricing",
                                        component: "./WWLNissan/NissanPricing",
                                    },
                                ],
                            },
                            {
                                name: "Nissan VPC Locations",
                                icon: "carry-out",
                                path: "/admin/wwl-nissan/nissan-vpc-locations",
                                authority: ["NissanService.VPCLocations"],
                                routes: [
                                    {
                                        path: "/admin/wwl-nissan/nissan-vpc-locations",
                                        component: "./WWLNissan/NissanVPCLocations",
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        name: "External Tools",
                        icon: "book",
                        path: "/admin/external",
                        component: "./AdminExternalTool",
                        authority: ["CoreService.ExternalTools"],
                    },
                    {
                        name: "Tags",
                        icon: "tags",
                        path: "/admin/tags",
                        component: "./AdminTags",
                        authority: ["TagService.Tags"],
                    },
                    {
                        name: "Gate Passes",
                        icon: "GatePass",
                        path: "/admin/gate-passes",
                        component: "./GatePasses",
                        authority: ["GatePassService.ProcessingJobs", "GatePassService.ProcessingResults"],
                    },
                    {
                        name: "Campaigns",
                        icon: "Megaphone",
                        path: "/admin/campaigns",
                        component: "./Campaigns",
                        authority: ["AdministrationService.Campaigns"],
                    },
                    {
                        name: "Contact Us",
                        icon: "mail",
                        path: "/contact-support",
                        component: "./ContactUs",
                        authority: ["CoreService.ContactUs"],
                    },
                    {
                        name: "Fallback",
                        path: "/fallback",
                        component: "./Fallback",
                        hideInMenu: true,
                        authority: true,
                    },
                    {
                        path: "/401",
                        component: "./401",
                        cannotRedirectTo: true,
                    },
                    {
                        component: "./404",
                        cannotRedirectTo: true,
                    },
                ],
            },
            {
                path: "/401",
                component: "./401",
                cannotRedirectTo: true,
            },
            {
                component: "./404",
                cannotRedirectTo: true,
            },
        ],
    },
    {
        path: "/401",
        component: "./401",
        cannotRedirectTo: true,
        public: true,
    },
    {
        component: "./404",
        cannotRedirectTo: true,
        public: true,
    },
];
